module.exports = __webpack_public_path__ + "media/images/icon__dropdown--arrow@2x-3f1a938159ea6c0d1f9b8ad2fa3e71cf.png";